import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { confirmBooking, unconfirmBooking } from 'actions/Teacher/reservationActions';
import ConfirmLessonCard from 'components/ConfirmLessonCard';
import Loading from 'components/Loading/Loading';

import './style.css';

class ConfirmLesson extends Component {
  constructor(props) {
    super(props);
    // This is because component is used in two ways in the page and modal
    const lessonId = get(props, 'routeParams.lessonId') || get(props, 'lessonId');
    this.state = {
      isSubmitting: true,
      isUnconfirmed: false,
      submitError: null,
      lessonId: lessonId,
    };
  }

  componentDidMount() {
    this.confirmLesson();
  }

  confirmLesson = () => {
    this.setState({ isSubmitting: true });
    this.props.confirmBooking(this.state.lessonId, () => {
      this.setState({ isSubmitting: false, isUnconfirmed: false });
    }, (error) => {
      this.setState({ submitError: error, isSubmitting: false });
    });
  }

  unconfirmLesson = () => {
    this.setState({ isSubmitting: true });
    this.props.unconfirmBooking(this.state.lessonId, () => {
      this.setState({ isSubmitting: false, isUnconfirmed: true });
    }, (error) => {
      this.setState({ submitError: error, isSubmitting: false });
    });
  }

  renderHomeButton = () => {
    return (<div className="mt-4">
      <button
        className="btn btn-primary"
        type="button"
        onClick={() => {
          browserHistory.push({
            pathname: '/'
          });
        }}
      >
        Go Home
      </button>
    </div>);
  }

  render() {
    const { isSubmitting, isUnconfirmed, submitError } = this.state;
    const { showHomeButton } = this.props;

    if (isSubmitting) {
      return (<div className="ConfirmLesson d-flex justify-content-center">
        <Loading />
      </div>);
    }

    if (submitError) {
      const errorMessage = get(submitError, 'response.data.message', 'Something went wrong');
      return (<ConfirmLessonCard>
        {errorMessage}
        {showHomeButton && this.renderHomeButton()}
      </ConfirmLessonCard>)
    }

    if (isUnconfirmed) {
      return (<ConfirmLessonCard>
        <p>We removed your confirmation of this appointment.</p>
        {showHomeButton && this.renderHomeButton()}
      </ConfirmLessonCard>)
    }

    return (
      <ConfirmLessonCard>
        <div className="title mb-4">THANK YOU</div>
        <p>Thank you for confirming the lesson.</p>
        <p>If this was an accident, <a href="#" onClick={this.unconfirmLesson}>click here</a> to remove the confirmation.</p>
        {showHomeButton && this.renderHomeButton()}
      </ConfirmLessonCard>
    );
  }
}

ConfirmLesson.defaultProps = {
  showHomeButton: true
};

export default connect(
  null,
  { confirmBooking, unconfirmBooking }
)(ConfirmLesson);



// WEBPACK FOOTER //
// ./src/pages/teacher/ConfirmLesson/index.js